module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('list', {
    ref: "list",
    attrs: {
      "scroll": true,
      "items": _vm.albums,
      "link": "album",
      "fields": ['name', 'band', 'date'],
      "type": "img"
    },
    on: {
      "update": _vm.getData
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c82afd5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/BandAlbums.vue
// module id = 282
// module chunks = 0